import {Component} from "@angular/core";
import {Router, ActivatedRoute} from "@angular/router";
import {WorkflowService} from "../workflow.service";
import {WorkflowStep} from "../workflow-step";

@Component({
  templateUrl: "./finalize-project.template.pug",
})

export class FinalizeProjectComponent extends WorkflowStep {
  public ready() {}

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
  ) {
    super();
  }
}
